"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListToolbarButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateList = require("@udecode/plate-list");
var _toolbar = require("./toolbar");
var _useListToolbarButton = require("../hooks/useListToolbarButton");
var _Icon = require("../../forecast-v2/components/media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var ListToolbarButton = exports.ListToolbarButton = (0, _cn.withRef)(function (_ref, ref) {
  var _ref$nodeType = _ref.nodeType,
    nodeType = _ref$nodeType === void 0 ? _plateList.ELEMENT_UL : _ref$nodeType,
    rest = _objectWithoutProperties(_ref, ["nodeType"]);
  var state = (0, _useListToolbarButton.useListToolbarButtonState)({
    nodeType: nodeType
  });
  var _ref2 = (0, _useListToolbarButton.useListToolbarButton)(state),
    props = _ref2.props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarButton, _objectSpread({
    ref: ref,
    tooltip: nodeType === _plateList.ELEMENT_UL ? 'Bulleted List' : 'Numbered List'
  }, props, rest, {
    children: nodeType === _plateList.ELEMENT_UL ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'bulletpoint'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'numberedBulletpoint'
    })
  }));
});